import React from 'react';
import { LOGO_PATHS, LOGO_VIEWBOX } from './loginLogoGeometry';

/**
 * Το σήμα Xentrix της ροής σύνδεσης (σύνδεση, επιλογή υπαλλήλου): επίπεδο, στο ΕΝΑ χρώμα της νέας
 * εμφάνισης — το πάνω σχήμα γεμάτο --brand, το κάτω στο ίδιο χρώμα πιο αχνό (όχι μπλε + βιολετί, όχι
 * διαβάθμιση). Στην οθόνη υπαλλήλου ακολουθεί έτσι και το χρώμα του καταστήματος.
 *
 * Ως 14/10/2026 εδώ ζούσε ένα γλυπτό WebGL (δύο ανάγλυφα κομμάτια με φωτισμό στούντιο) και μια
 * χορογραφία 4,6″ πριν φανεί η φόρμα. Στη νέα εμφάνιση έφυγε: τα χρώματά του ήταν σταθερά μπλε/βιολετί
 * και δεν ακολουθούσαν το brand, και ο ταμίας που συνδέεται κάθε μέρα περίμενε ~3″ να εμφανιστεί η
 * φόρμα. Το όνομα του αρχείου έμεινε ίδιο, για να μη χαθεί η ιστορία του στο git.
 */
const LoginLogoMark: React.FC<{ className?: string }> = ({ className = 'xl-mark' }) => (
  <svg className={className} viewBox={LOGO_VIEWBOX} aria-hidden="true" focusable="false" data-testid="xentrix-mark">
    <path d={LOGO_PATHS[0]} style={{ fill: 'hsl(var(--brand))' }} data-testid="xentrix-mark-shape" />
    <path d={LOGO_PATHS[1]} style={{ fill: 'hsl(var(--brand))', opacity: 0.55 }} data-testid="xentrix-mark-shape" />
  </svg>
);

export default LoginLogoMark;
